import { useMemo } from 'react';
import { useTheme } from 'next-themes';
import ReactApexChart from 'react-apexcharts';
import type { ApexOptions } from 'apexcharts';
import { chartThemeOptions } from './chartTheme';

type Props = {
  options: ApexOptions;
  series: ApexAxisChartSeries | ApexNonAxisChartSeries;
  type: NonNullable<ApexOptions['chart']>['type'];
  width?: number | string;
  height?: number | string;
};

export function ApexChart({ options, series, type, width, height = 280 }: Props) {
  const { resolvedTheme } = useTheme();
  const merged = useMemo(() => {
    const themed = chartThemeOptions(resolvedTheme === 'dark' ? 'dark' : 'light');
    return mergeOptions(themed, options);
  }, [options, resolvedTheme]);
  return (
    <ReactApexChart
      options={merged}
      series={series as ApexAxisChartSeries}
      type={type}
      width={width}
      height={height}
    />
  );
}

function mergeOptions(base: ApexOptions, over: ApexOptions): ApexOptions {
  return {
    ...base,
    ...over,
    chart: { ...(base.chart ?? {}), ...(over.chart ?? {}) },
    grid: { ...(base.grid ?? {}), ...(over.grid ?? {}) },
    legend: { ...(base.legend ?? {}), ...(over.legend ?? {}) },
    tooltip: { ...(base.tooltip ?? {}), ...(over.tooltip ?? {}) },
  };
}
